/*
 * @Author: randy
 * @Date: 2020-07-31 10:25:59
 * @LastEditTime: 2020-09-10 14:48:57
 * @Description: 消息工具函数
 */

import { message, notification } from "ant-design-vue";
import router from "@/router";
/**
 * @Author: randy
 * @description: 顶部消息提示
 * @param {type 类型，content 内容，duration 时间默认3秒}
 * @return: undefined
 */
export const showMessage = (type = "success", content = "", duration = 3) => {
  message[type](content, duration);
};

/**
 * @Author: randy
 * @description: 侧边消息提示
 * @param {type 类型，message 标题，description 内容，duration 时间默认4.5秒}
 * @return: undefine
 */
export const showNotification = (
  type = "success",
  message = "",
  description = "",
  duration = 4.5
) => {
  notification[type]({ message, description, duration });
};

/**
 * @Author: randy
 * @description: 流程消息提示
 * @param {type 类型，message 标题，description 内容，duration 时间默认4.5秒}
 * @return: undefine
 */
export const showStepNotification = data => {
  const key = `open${Date.now()}`;
  notification.open({
    message: "提示",
    description: data.message,
    duration: null,
    key,
    icon: h => {
      return h("a-icon", {
        style: {
          color: "#faad14"
        },
        props: {
          type: "exclamation-circle"
        }
      });
    },
    btn: h => {
      return h(
        "a-button",
        {
          props: {
            type: "primary",
            size: "small"
          },
          on: {
            click: () => {
              notification.close(key);
              router.push({ name: data.results.url });
            }
          }
        },
        "前往"
      );
    }
  });
};
